/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IntegrationFinancialUploadBatchExcelFile'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./IntegrationFinancialUploadBatchExcelFile'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationFinancialUploadBatchFileReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.IntegrationFinancialUploadBatchExcelFile);
  }
}(this, function(ApiClient, IntegrationFinancialUploadBatchExcelFile) {
  'use strict';




  /**
   * The IntegrationFinancialUploadBatchFileReport model module.
   * @module model/IntegrationFinancialUploadBatchFileReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationFinancialUploadBatchFileReport</code>.
   * @alias module:model/IntegrationFinancialUploadBatchFileReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>IntegrationFinancialUploadBatchFileReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationFinancialUploadBatchFileReport} obj Optional instance to populate.
   * @return {module:model/IntegrationFinancialUploadBatchFileReport} The populated <code>IntegrationFinancialUploadBatchFileReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ExcelDetails')) {
        obj['ExcelDetails'] = IntegrationFinancialUploadBatchExcelFile.constructFromObject(data['ExcelDetails']);
      }
      if (data.hasOwnProperty('BatchID')) {
        obj['BatchID'] = ApiClient.convertToType(data['BatchID'], 'Integer');
      }
      if (data.hasOwnProperty('FileBlobURI')) {
        obj['FileBlobURI'] = ApiClient.convertToType(data['FileBlobURI'], 'String');
      }
      if (data.hasOwnProperty('FileName')) {
        obj['FileName'] = ApiClient.convertToType(data['FileName'], 'String');
      }
      if (data.hasOwnProperty('MimeType')) {
        obj['MimeType'] = ApiClient.convertToType(data['MimeType'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/IntegrationFinancialUploadBatchExcelFile} ExcelDetails
   */
  exports.prototype['ExcelDetails'] = undefined;
  /**
   * @member {Integer} BatchID
   * @default 0
   */
  exports.prototype['BatchID'] = 0;
  /**
   * @member {String} FileBlobURI
   * @default ''
   */
  exports.prototype['FileBlobURI'] = '';
  /**
   * @member {String} FileName
   * @default ''
   */
  exports.prototype['FileName'] = '';
  /**
   * @member {String} MimeType
   * @default ''
   */
  exports.prototype['MimeType'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


